module.exports = __webpack_public_path__ + "static/media/HappyChildren.41e1ce30.png";